import Api from "lib/api/httpRequestHelper";

export function mapLabelOptions(list) {
  if (!Array.isArray(list)) return [];
  return list
    .filter((item) => item != null && String(item).trim() !== "")
    .map((item) => {
      const label =
        typeof item === "string"
          ? item.trim()
          : String(item?.Descricao ?? item).trim();
      return { id: label, label };
    });
}

export function buildQueryString(params) {
  const parts = Object.entries(params).filter(
    ([, value]) => value != null && value !== "",
  );
  if (parts.length === 0) return "";
  return "?" + parts.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
}

async function loadDimensionOptions({
  idMarca,
  tipo,
  linhaVenda,
  grade,
  colecao,
  filter,
}) {
  if (!idMarca || !tipo) return [];

  const query = buildQueryString({
    idMarca,
    tipo,
    linhaVenda: linhaVenda?.trim() || undefined,
    grade: grade?.trim() || undefined,
    colecao: colecao?.trim() || undefined,
    filter: filter?.trim() || undefined,
  });

  const response = await Api.get(
    "product-grade-venda-dimension-list",
    "showcaseB2B",
    query,
    true,
  );

  return mapLabelOptions(response?.Result ?? []);
}

/** Linha de venda WMW (categoria de alto nível, ex.: Cama, Banho, Mesa). Cascateia pela Grade e Coleção selecionadas. */
export async function loadLinhaVendaOptions({ idMarca, filter, grade, colecao }) {
  return loadDimensionOptions({ idMarca, tipo: "linhavenda", grade, colecao, filter });
}

/** Grade (nome comercial). Cascateia pela Linha de venda e Coleção selecionadas. */
export async function loadGradeOptions({ idMarca, filter, linhaVenda, colecao }) {
  return loadDimensionOptions({
    idMarca,
    tipo: "grade",
    linhaVenda,
    colecao,
    filter,
  });
}

/** Coleção. Cascateia pela Linha de venda e Grade selecionadas. */
export async function loadCollectionOptions({
  idMarca,
  linhaVenda,
  grade,
  filter,
}) {
  return loadDimensionOptions({
    idMarca,
    tipo: "colecao",
    linhaVenda,
    grade,
    filter,
  });
}
